import { Nullable } from "../types/Nullable";

export function isValidRouterNumber(arg?: Nullable<unknown>): arg is number {
  return typeof arg === "number" && !isNaN(arg) && arg > -1;
}
